<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Vigencia cotización</span
            >
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form
            class="form"
            [formGroup]="formVigenciaCotizacion"
            autocomplete="off"
        >
            <mat-form-field class="full-width">
                <mat-label>Fecha de vigencia </mat-label>

                <input
                    matInput
                    [matDatepicker]="fechaDatePicker"
                    [min]="minFecha"
                    name="fecha"
                    formControlName="fecha"
                    readonly
                />
                <mat-datepicker-toggle
                    matSuffix
                    [for]="fechaDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #fechaDatePicker></mat-datepicker>
                <mat-error *ngIf="fecha.hasError('required')">
                    Debe ingresar la fecha de vigencia
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formVigenciaCotizacion.value"
            [disabled]="!formVigenciaCotizacion.valid"
        >
            Enviar Cotización
        </button>
    </mat-dialog-actions>
</div>
